import React, { useCallback, useEffect, useMemo } from 'react';
import { useSignals } from '@preact/signals-react/runtime';
import ReactDOM from 'react-dom/client';
import jsonData from './signals/jsonData';
import appState from './signals/appState';
import setLanguage from './hooks/setLanguage';
import Loading from './components/Loading';
import LeftPanel from './components/LeftPanel';
import MapArea from './components/MapArea';
import RightPanel from './components/RightPanel';
import ExhibitorList from './components/ExhibitorList';
import MyFavourites from './components/MyFavourites';
import ExhibitionInfo from './components/ExhibitionInfo';
import ExhibitorInfo from './components/ExhibitorInfo';
import ExhibitorListPrint from './components/ExhibitorListPrint';
import SearchPanel from './components/SearchPanel';
import './sass/index.sass';

const currentUrl = window.location.href;
const root = ReactDOM.createRoot(document.getElementById('root'));
let className = '';

const MultiFloor = () => {
	const { floorInfo } = jsonData.value;
	const { loading } = appState.value;

	const filteredFloorInfo = useMemo(() => {
		return floorInfo.filter((floor) => {
			return floor.floor !== '';
		});
	}, [floorInfo]);

	useEffect(() => {
		document.body.style.overflow = 'auto';
		document.documentElement.style.overflow = 'auto';

		if (!loading) {
			setTimeout(() => {
				window.print();
			}, 2000);
		}
	}, [loading]);

	return (
		<div id='App' className='multi-floor' >
			{filteredFloorInfo.map((floor, index) => {
				return (
					<MapArea isPrint floor={floor} key={`map${index}`} />
				);
			})}
			<Loading />
		</div>
	);
};

const urlParams = new URLSearchParams(window.location.search);
const Location = urlParams.get('location');
const Start = urlParams.get('start');
const booth = urlParams.get('booth');
const Floor = urlParams.get('floor');
const Lang = urlParams.get('lang');

if (Location) localStorage.setItem('Location', Location);
if (Start) localStorage.setItem('Start', Start);

const AppWrapper = () => {
	useSignals();

	const { exhibitorInfo, floorInfo, languages } = jsonData.value;

	useEffect(() => {
		if (booth) {
			const upperCaseBooth = booth.toUpperCase();
			const boothInfo = exhibitorInfo.find((exhibitor) => exhibitor['攤位號碼'] === upperCaseBooth);
			if (boothInfo) {
				const floor = boothInfo.floor;

				appState.value = {
					...appState.value,
					ExhibitorInfo: true,
					activeFloor: floor,
					selectedBooth: upperCaseBooth,
					selectedExhibitor: upperCaseBooth,
				};
			}
		}
	}, [exhibitorInfo, floorInfo]);

	const fetchJsonData = useCallback(() => {
		fetch('./data-common.json')
			.then(response => response.json())
			.then((data) => {
				console.log('common data', data);
				jsonData.value = {
					...jsonData.value,
					languages: data.languages,
					basicInfo: {
						...jsonData.value.basicInfo,
						floorCount: data.basicInfo.floorCount,
						boothColor: data.basicInfo.boothColor,
					},
					floorInfo: jsonData.value.floorInfo.map((floor, index) => {
						return {
							...floor,
							floor: data.floorInfo[index].floor,
							booths: data.floorInfo[index].booths,
							sections: data.floorInfo[index].sections,
							paths: data.floorInfo[index].paths,
						};
					}),
				};
			})
			.catch(() => {
				alert('匯入共用資料錯誤');
			});
	}, [])

	useEffect(() => {
		fetchJsonData();
	}, [fetchJsonData]);

	useEffect(() => {
		if (Floor) {
			appState.value = {
				...appState.value,
				activeFloor: Number(Floor),
			};
		}
	}, [floorInfo]);

	useEffect(() => {
		const browserLang = navigator.language;
		const hasLanguage = languages.find((language) => language.code === browserLang);
		const firstLanguage = languages[0];

		if (Lang) {
			setLanguage(Lang);
		} else if (hasLanguage) {
			setLanguage(browserLang);
		} else if (firstLanguage) {
			setLanguage(firstLanguage.code);
		}
	}, [languages]);

	if (currentUrl.includes('single-floor')) {
		return (
			<div id='App' className='single-floor'>
				<MapArea isPrint />
				<Loading />
			</div>
		);
	}

	if (currentUrl.includes('multi-floor')) {
		return <MultiFloor />;
	}

	if (currentUrl.includes('exhibitor-list')) {
		return <ExhibitorListPrint />;
	}

	return (
		<div id='App' className={className}>
			<LeftPanel />
			<MapArea />
			<RightPanel />
			<ExhibitorList />
			<MyFavourites />
			<ExhibitionInfo />
			<ExhibitorInfo />
			<SearchPanel />
			<Loading />
		</div>
	);
}

// if (currentUrl.includes('single-floor')) {
// 	root.render(
// 		<div id='App' className='single-floor'>
// 			<MapArea isPrint />
// 			<Loading />
// 		</div>
// 	);
// }

// else if (currentUrl.includes('multi-floor')) {
// 	root.render(<MultiFloor />);
// }

// else if (currentUrl.includes('exhibitor-list')) {
// 	root.render(<ExhibitorListPrint />);
// }

// else {
// 	root.render(
// 		<div id='App' className={className}>
// 			<AppWrapper />
// 		</div>
// 	);
// }

root.render(
	<div id='App' className={className}>
		<AppWrapper />
	</div>
);

